import { IFlowEventData } from 'types/analytics';
import { trackingFlowSubTypes } from 'constants/analytics';
import { WIDGET_NAME } from '@sitegen/common/constants';

export const TEXT_KEYS = {
    REDEEM_ITEM_BACK_SELECTION: 'redeem-item-selection-page__back-selection',
    REDEEM_ITEM_SELECT_GAME: 'redeem-item-selection-page__select-game',
    REDEEM_SUCCESS_GIFT_DESCRIPTION: 'redeem-success__gift-description',
    REDEEM_SUCCESS_GIFT_DETAILS: 'redeem-success__gift-details'
};

export const ITEMS_SELECTION_FLOW_STEP: Pick<IFlowEventData, 'flowStep'|'flowSubType'> = {
    flowStep: 'item selection',
    flowSubType: trackingFlowSubTypes[WIDGET_NAME.PYC_REDEEM]
};
